module.exports = __webpack_public_path__ + "static/img/steel-pipe_256.02aec4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steel-pipe_256.png
// module id = POWR
// module chunks = 0